import React from "react";
import MemberBreakdownSkeleton from "./MemberBreakdownSkeleton";

// SG-2164: shared "Breakdown by member" renderer.
//  - mode "count" (default): value is the member's raw count; the progress bar is that member's share
//    of the total across all rows (bars comparable within the widget, not across widgets).
//  - mode "rate": value is the member's rate as a percentage with the underlying counts shown
//    (e.g. "42% · 12/28" — so a 1/1 = 100% row reads honestly); the bar is the rate itself out of 100
//    (a rate is not additive, so a share-of-total bar would be meaningless).
// While the breakdown data is being fetched (loading), show the skeleton liner loader in its place.
const MemberBreakdownList = ({ rows, loading, mode = "count" }) => {
  if (loading) return <MemberBreakdownSkeleton />;
  if (!rows?.length) return null;
  const isRate = mode === "rate";
  const total = isRate ? 0 : rows.reduce((sum, r) => sum + (r.count || 0), 0);
  return (
    <div className="widgetCardMemberBreakdown">
      {rows.map(r => {
        const pct = isRate
          ? Math.min(100, Math.max(0, Math.round(r.rate || 0)))
          : total > 0
          ? Math.min(100, Math.round(((r.count || 0) / total) * 100))
          : 0;
        const valueLabel = isRate ? `${(r.rate || 0).toFixed(1)}%` : r.count;
        return (
          <div key={r.memberId} className="widgetCardMemberBreakdownRow">
            <div className="widgetCardMemberBreakdownHeader">
              <span className="widgetCardMemberBreakdownName">{r.name || r.memberId}</span>
              <span className="widgetCardMemberBreakdownValue">
                {valueLabel}
                {isRate && r.denominator != null && (
                  <span className="widgetCardMemberBreakdownSub"> · {r.numerator}/{r.denominator}</span>
                )}
              </span>
            </div>
            <div className="widgetCardMemberBreakdownBarTrack">
              <div className="widgetCardMemberBreakdownBarFill" style={{ width: `${pct}%` }} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MemberBreakdownList;
